module.exports = __webpack_public_path__ + "static/assets/af8e46c9477a8cadeb6c26b4686407a5.svg";